import { BASE_URL } from '../config';

const httpService = {
    getData: async (endpoint, params = {}, requiresAuth = false) => {
        try {
        const url = new URL(`${BASE_URL}${endpoint}`);
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        const headers = {
            'Content-Type': 'application/json',
        };

        if (requiresAuth) {
            //const token = sessionStorage.getItem("accessToken");
            const token = sessionStorage.getItem("accessToken");
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
        }

        const response = await fetch(url, { method: 'GET', headers: headers });
        /* if (response.status === 401) {
            console.error("Unauthorized access - logging out...");
            sessionStorage.removeItem("userDetails");
            sessionStorage.removeItem("accessToken");
            window.location.href = "/login"; 
            return null;
        } */

        return await response.json();
        } catch (error) {
            console.error('GET request error:', error);
            throw error;
        }
    },

    postData: async (endpoint, data, config = {}) => {
        try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...config.headers },
            body: JSON.stringify(data),
        });
        return await response.json();
        } catch (error) {
        console.error('POST request error:', error);
        throw error;
        }
    },

    postFormData: async (endpoint, formData, config = {}) => {
        try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'POST',
            headers: {
            ...config.headers // DO NOT manually set 'Content-Type' here
            },
            body: formData,
        });
        return await response.json();
        } catch (error) {
        console.error('FormData POST request error:', error);
        throw error;
        }
    },

    putData: async (endpoint, data, config = {}) => {
        try {
        const response = await fetch(`${BASE_URL}${endpoint}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...config.headers },
            body: JSON.stringify(data),
        });
        return await response.json();
        } catch (error) {
        console.error('PUT request error:', error);
        throw error;
        }
    },

};

export default httpService;